import { call, put, select, takeLatest } from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';
import globalErrorHandler from 'react/api/GlobalErrorHandler.js';

export const urlAggregate = '/PendingOrder/aggregate';
export const bodyAggregate = {
  criteriaChain: [
    {
      and: [
        {
          attr: 'assignedBy',
          isNull: true,
        },
        {
          attr: 'assignedDate',
          isNull: true,
        },
        {
          attr: 'assignedOrder',
          isNull: true,
        },
      ],
    },
  ],
  aggregate: [
    {
      function: 'COUNT',
      attr: [
        'id',
      ],
    },
  ],
};

export function* pendingOrdersAggregateSaga() {
  const data = yield call(defaultFetch, urlAggregate, bodyAggregate, 'POST');
  const { error } = data;

  if (error) {
    yield globalErrorHandler(error);
  } else {
    const { count: { total: payload } } = data;
    yield put({
      type: 'GREENMILE_ROUTEMONITOR_PENDING_ORDERS_AGGREGATE_SUCCESS',
      payload,
    });
  }
}

export function* pendingOrdersAggregate() {
  yield takeLatest('GREENMILE_ROUTEMONITOR_PENDING_ORDERS_AGGREGATE_REQUEST', pendingOrdersAggregateSaga);
}

export const url = '/PendingOrder/restrictions?criteria=%7B%22filters%22:%5B%22id%22,%22number%22,%22createdDate%22,%22location.*%22,%22priority%22,%22plannedSize1%22,%22plannedPickupSize1%22,%22specialInstructions%22%5D%7D';
export const body = {
  criteriaChain: [
    {
      and: [
        {
          attr: 'assignedBy',
          isNull: true,
        },
        {
          attr: 'assignedDate',
          isNull: true,
        },
        {
          attr: 'assignedOrder',
          isNull: true,
        },
      ],
    },
  ],
  aggregate: [
    {
      function: 'COUNT',
      attr: [
        'id',
      ],
    },
  ],
  sort: [
    {
      attr: 'number',
      type: 'ASC',
    },
  ],
};

export function* pendingOrdersSaga() {
  const payload = yield call(defaultFetch, url, body, 'POST');
  const { error } = payload;
  if (error) {
    yield globalErrorHandler(error);
  } else {
    yield put({
      type: 'GREENMILE_ROUTEMONITOR_PENDING_ORDERS_SUCCESS',
      payload,
    });
  }
}

function* updatePendingOrdersRowSaga() {
  const { routeMonitor } = yield select();
  yield call(pendingOrdersAggregateSaga);
  if (routeMonitor.pendingOrderRow.open) {
    yield call(pendingOrdersSaga);
  }
}

export function* updatePendingOrdersRow() {
  yield takeLatest('GREENMILE_ROUTEMONITOR_UPDATE_PENDING_ORDERS_ROW', updatePendingOrdersRowSaga);
}

export default function* pendingOrders() {
  yield takeLatest('GREENMILE_ROUTEMONITOR_PENDING_ORDERS_REQUEST', pendingOrdersSaga);
}
